import { html, rune, type Html, View } from 'rune-ts';
import klass from './BottomSection.module.scss';
import { typoPcMo } from '../../../../../shared/typography/typo';

export class BottomSection extends View {
  constructor() {
    super({});
  }

  override template(): Html {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;

    const texts = {
      bottom_title: is_mobile
        ? html.preventEscape(ET(`mps2::landing::handmade::mo_bottom_title`))
        : html.preventEscape(ET(`mps2::landing::handmade::bottom_title`)),
      bottom_description: is_mobile
        ? html.preventEscape(ET(`mps2::landing::handmade::mo_bottom_description`))
        : html.preventEscape(ET(`mps2::landing::handmade::bottom_description`)),
    };

    return html`
      <section class="${klass.bottom}">
        <div class="${klass.video_container}">
          <div class="${klass.video_wrapper}">
            <video
              preload="none"
              autoplay=""
              loop=""
              muted=""
              playsinline=""
              class="${klass.motion_video}"
              src="//s3.ap-northeast-2.amazonaws.com/s3.marpple.co/files/u_4648126/2024/10/original/hands-baking-cookies.mp4"
            ></video>
          </div>
        </div>
        <div class="${klass.content}">
          <div class="${klass.title} ${typoPcMo({ is_mobile, pc: '48_bold', mo: '28_bold' })}">
            ${texts.bottom_title}
          </div>
          <div class="${klass.description} ${typoPcMo({ is_mobile, pc: '20_medium', mo: '14_regular' })}">
            ${texts.bottom_description}
          </div>
        </div>
      </section>
    `;
  }
}
